
import JobList from './JobsMain.vue'
import TodaysJobs from './TodaysJobs.vue'

const config = {
	mainRoute: {
		name: "Jobs",
		path: "/jobs",
		component: JobList
	},
	todaysJobs: {
		name: "todaysJobs",
		path: "/todays-jobs",
		component: TodaysJobs
	},
	nav: {
		name: 'nav.jobsMeetings',
		to: "Jobs",
		position: 1,
		show: true
	},
	module: "jobs",
	todaysModule: "todaysJobs"
}

export { config }